import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/session-groups/')({
  beforeLoad: () => {
    throw redirect({ to: '/learn' });
  },
});
